import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { PageHeaderComponent } from '../../../shared/components/ui/page-header/page-header.component';
import { toErrorMessage } from '../../../shared/helpers/http-error';
import { PaymentMethodsService } from '../../../shared/services/payment-methods.service';
import { PaymentMethodWriteRequest } from '../../../shared/types/payment-method.types';
import { PaymentMethodFormComponent } from '../payment-method-form/payment-method-form.component';

@Component({
  selector: 'app-payment-method-create',
  imports: [PageHeaderComponent, PaymentMethodFormComponent],
  templateUrl: './payment-method-create.component.html',
})
export class PaymentMethodCreateComponent {
  private readonly service = inject(PaymentMethodsService);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  readonly submitting = signal(false);
  readonly serverError = signal<string | null>(null);

  onSave(payload: PaymentMethodWriteRequest): void {
    this.submitting.set(true);
    this.serverError.set(null);
    this.service
      .create(payload)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (created) => {
          this.submitting.set(false);
          void this.router.navigate(
            created.id ? ['/payment-methods', created.id] : ['/payment-methods'],
          );
        },
        error: (err: unknown) => {
          this.submitting.set(false);
          this.serverError.set(
            toErrorMessage(err, 'La création a échoué.', {
              409: 'Un code service identique existe déjà.',
            }),
          );
        },
      });
  }

  onCancel(): void {
    void this.router.navigate(['/payment-methods']);
  }
}
